import React, { useState } from "react";
import FormContainer from "../Components/Form/FormContainer";
import Input from "../Components/Form/Input";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Error from "../Components/Alerts/Error";
import {
  auth,
  signInWithEmailAndPassword,
  firestore,
} from "../Firebase/config";
import { login as userLogin } from "../Features/userSlice";
import { useDispatch } from "react-redux";
import { where, query, collection, getDocs } from "firebase/firestore";
import { getWorkoutData } from "../Features/workoutSlice";
import { getDiet } from "../Features/DietSlice";
import Loader from "../Components/Loader";

export default function Login() {
  const { register, handleSubmit, formState } = useForm();
  const { errors } = formState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLording, setIsLording] = useState(false);

  const [error, setError] = useState();

  const login = (data) => {
    setIsLording(true);
    signInWithEmailAndPassword(auth, data.email, data.password)
      .then(async (userCredential) => {
        // const user = userCredential.user;
        // logEvent(analytics, "user_data", {
        //   email: data.email,
        // });
        try {
          const q = query(
            collection(firestore, "users"),
            where("email", "==", data.email)
          );
          const docId = await getDocs(q);
          const userDoc = docId.docs.map((doc) => doc);
          dispatch(userLogin({ ...userDoc[0].data(), docId: userDoc[0].id }));
          dispatch(getWorkoutData(userDoc[0].id));
          dispatch(getDiet(userDoc[0].id));
          navigate("/");
          setIsLording(false);
        } catch (error) {
          // console.log(error);
          setIsLording(false);
        }
      })
      .catch((error) => {
        setError(error.message);
        setIsLording(false);
      });
  };

  return (
    <FormContainer>
      <Loader isLording={isLording} />
      {errors.password?.message && <Error message={errors.password.message} />}
      {errors.email?.message && <Error message={errors.email.message} />}
      {error && <Error message={error} />}
      <div className="w-full rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 bg-gray-800 border-gray-700">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-xl font-bold leading-tight tracking-tight  md:text-2xl text-white">
            Login
          </h1>
          <form
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(login)}
          >
            <Input
              label="Email"
              type="email"
              placeholder="name@company.com"
              {...register("email", {
                required: "Enter Your Email",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter Valid Email",
                },
              })}
            />
            <Input
              label="password"
              type="password"
              placeholder="********"
              {...register("password", {
                required: "Enter Password",
                validate: (value) => {
                  return (
                    (8 < value.length && value.length < 16) ||
                    "Password Length is between 8-16"
                  );
                },
              })}
            />
            <p className="text-sm font-light  text-gray-400 text-right">
              <Link
                to="/reset"
                className="font-medium hover:underline text-blue-500"
              >
                Forgot Password ?
              </Link>
            </p>
            <button
              type="submit"
              className="w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-blue-600 hover:bg-bule-700 focus:ring-blue-800"
            >
              Login
            </button>
            <p className="text-sm font-light  text-gray-400">
              Create account{" "}
              <Link
                to="/signup"
                className="font-medium hover:underline text-blue-500"
              >
                Click here
              </Link>
            </p>
          </form>
        </div>
      </div>
    </FormContainer>
  );
}
